/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../notification/message/message.component.ngfactory';
import * as import2 from '../../notification/message/message.component';
import * as import3 from '../../notification/notification.service';
import * as import4 from '../../inputs/selection-field/selection-field.component.ngfactory';
import * as import5 from '../../inputs/selection-field/selection-field.component';
import * as import6 from 'ng2-translate/src/translate.service';
import * as import7 from '../../orchestration/navigation.service';
import * as import8 from 'ng2-translate/src/translate.pipe';
import * as import9 from '@angular/forms';
import * as import10 from '@angular/common';
import * as import11 from '../../ui-elements/spinner/spinner.component.ngfactory';
import * as import12 from '../../ui-elements/spinner/spinner.component';
import * as import13 from '../../buttons/button/button.component.ngfactory';
import * as import14 from '../../buttons/button/button.component';
import * as import15 from '../../orchestration/session.model';
import * as import16 from '../../orchestration/responsive.service';
import * as import17 from '../../page-layout/page-footer-control.directive';
import * as import18 from '../../page-layout/modal-page-layout/modal-page-layout.component.ngfactory';
import * as import19 from '../../page-layout/modal-page-layout/modal-page-layout.component';
import * as import20 from '../../orchestration/page';
import * as import21 from '../../orchestration/responsive.directive';
import * as import22 from './order-time-selection-page.component';
import * as import23 from '../../orchestration/navigation-params';
import * as import24 from '../ordering-context.model';
import * as import25 from '../../order/order.model';
const styles_OrderTimeSelectionPageComponent:any[] = ([] as any[]);
export const RenderType_OrderTimeSelectionPageComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_OrderTimeSelectionPageComponent,
  data: {}
}
);
function View_OrderTimeSelectionPageComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),3,'woa-content-message',([] as any[]),[
      [
        2,
        'closable',
        (null as any)
      ]
      ,
      [
        2,
        'actionable',
        (null as any)
      ]
      ,
      [
        2,
        'errorLevel',
        (null as any)
      ]
      ,
      [
        2,
        'warningLevel',
        (null as any)
      ]
      ,
      [
        2,
        'successLevel',
        (null as any)
      ]
      ,
      [
        2,
        'infoLevel',
        (null as any)
      ]
      ,
      [
        2,
        'horizontal',
        (null as any)
      ]
      ,
      [
        2,
        'vertical',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import1.View_ContentMessageComponent_0,import1.RenderType_ContentMessageComponent)),
      import0.ɵdid(5488640,[[
        2,
        4
      ]
    ],1,import2.ContentMessageComponent,[
      import0.ElementRef,
      import3.NotificationService
    ]
    ,{
      level: [
        0,
        'level'
      ]
      ,
      text: [
        1,
        'text'
      ]
      ,
      translationParams: [
        2,
        'translationParams'
      ]

    }
    ,(null as any)),
    import0.ɵqud(603979776,4,{links: 1}),
    import0.ɵpod(['storeName'])
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_8:any = co.MessageLevel.ERROR;
    const currVal_9:any = 'woa.message.order-time.storeNameClosed';
    const currVal_10:any = ck(v,3,0,((co.orderingContextModel.currentStoreLocation == null)? (null as any): co.orderingContextModel.currentStoreLocation.storeName));
    ck(v,1,0,currVal_8,currVal_9,currVal_10);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).closable;
    const currVal_1:any = import0.ɵnov(v,1).actionable;
    const currVal_2:any = import0.ɵnov(v,1).isErrorLevel;
    const currVal_3:any = import0.ɵnov(v,1).isWarningLevel;
    const currVal_4:any = import0.ɵnov(v,1).isSuccessLevel;
    const currVal_5:any = import0.ɵnov(v,1).isInfoLevel;
    const currVal_6:any = import0.ɵnov(v,1).isHorizontalLayout;
    const currVal_7:any = import0.ɵnov(v,1).isVerticalLayout;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
  });
}
function View_OrderTimeSelectionPageComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'woa-selection-field',[[
        'class',
        'timing-selection-field date'
      ]
      ],(null as any),[[
        (null as any),
        'onActivateField'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivateField' === en)) {
        const pd_0:any = ((<any>co.toggleDateSelection()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import4.View_SelectionFieldComponent_0,import4.RenderType_SelectionFieldComponent)),
    import0.ɵdid(180224,(null as any),1,import5.SelectionFieldComponent,[
      import0.ChangeDetectorRef,
      import6.TranslateService,
      import7.NavigationService
    ]
    ,{
      label: [
        0,
        'label'
      ]
      ,
      disabled: [
        1,
        'disabled'
      ]
      ,
      value: [
        2,
        'value'
      ]
      ,
      noMessage: [
        3,
        'noMessage'
      ]
      ,
      toggleActive: [
        4,
        'toggleActive'
      ]

    }
    ,{onActivateField: 'onActivateField'}),
    import0.ɵqud(603979776,5,{optionComponents: 1}),
    import0.ɵpid(131072,import8.TranslatePipe,[
      import6.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    import0.ɵprd(5120,(null as any),import9.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import5.SelectionFieldComponent])
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'woa.label.order-time.date';
    const currVal_1:any = co.loadingTimes;
    const currVal_2:any = import0.ɵunv(v,1,2,import0.ɵnov(v,3).transform(co.dateFieldValue(co.orderDate)));
    const currVal_3:any = true;
    const currVal_4:any = co.showDateSelect;
    ck(v,1,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4);
  },(null as any));
}
function View_OrderTimeSelectionPageComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'woa-selection-field',[[
        'class',
        'timing-selection-field time'
      ]
      ],(null as any),[[
        (null as any),
        'onActivateField'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivateField' === en)) {
        const pd_0:any = ((<any>co.toggleTimeSelection()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import4.View_SelectionFieldComponent_0,import4.RenderType_SelectionFieldComponent)),
    import0.ɵdid(180224,(null as any),1,import5.SelectionFieldComponent,[
      import0.ChangeDetectorRef,
      import6.TranslateService,
      import7.NavigationService
    ]
    ,{
      label: [
        0,
        'label'
      ]
      ,
      disabled: [
        1,
        'disabled'
      ]
      ,
      value: [
        2,
        'value'
      ]
      ,
      noMessage: [
        3,
        'noMessage'
      ]
      ,
      toggleActive: [
        4,
        'toggleActive'
      ]

    }
    ,{onActivateField: 'onActivateField'}),
    import0.ɵqud(603979776,6,{optionComponents: 1}),
    import0.ɵpid(131072,import8.TranslatePipe,[
      import6.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    import0.ɵprd(5120,(null as any),import9.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import5.SelectionFieldComponent])
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'woa.label.order-time.time';
    const currVal_1:any = (co.loadingTimes || !co.timesAvailable);
    const currVal_2:any = import0.ɵunv(v,1,2,import0.ɵnov(v,3).transform(co.timeFieldValue()));
    const currVal_3:any = true;
    const currVal_4:any = co.showTimeSelect;
    ck(v,1,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4);
  },(null as any));
}
function View_OrderTimeSelectionPageComponent_5(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),5,'div',[[
        'class',
        'timing-select-date-list-content-date'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.selectDate(v.context.$implicit)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'timing-select-date-list-content-date-button'
      ]
      ],[[
        8,
        'id',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                            ',
      '\n                        '
    ]
    )),
    import0.ɵpid(131072,import8.TranslatePipe,[
      import6.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                    ']))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵinlineInterpolate(1,'date-button-',v.context.index,'');
    ck(v,2,0,currVal_0);
    const currVal_1:any = import0.ɵunv(v,3,0,import0.ɵnov(v,4).transform(co.dateFieldValue(v.context.$implicit)));
    ck(v,3,0,currVal_1);
  });
}
function View_OrderTimeSelectionPageComponent_4(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'timing-select-date-list drop-down'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'timing-select-date-list-content'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderTimeSelectionPageComponent_5)),
    import0.ɵdid(802816,(null as any),0,import10.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.availableDates;
    ck(v,5,0,currVal_0);
  },(null as any));
}
function View_OrderTimeSelectionPageComponent_8(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),8,'div',[[
        'class',
        'timing-select-time-grid-content-group-time'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),5,'div',[[
        'class',
        'timing-select-time-grid-content-group-time-cell'
      ]
      ],[[
        8,
        'id',
        0
      ]
      ],[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.selectTime(v.context.$implicit)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import10.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod([
      'unavailable',
      'carryOver'
    ]
    ),
    (l()(),import0.ɵted((null as any),[
      '\n                                ',
      '\n                            '
    ]
    )),
    import0.ɵpod(['time']),
    import0.ɵpid(131072,import8.TranslatePipe,[
      import6.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                        ']))
  ]
  ,(ck,v) => {
    const currVal_1:any = 'timing-select-time-grid-content-group-time-cell';
    const currVal_2:any = ck(v,4,0,!v.context.$implicit.available,v.context.$implicit.carryOver);
    ck(v,3,0,currVal_1,currVal_2);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵinlineInterpolate(2,'time-grid-button-',(<any>v.parent).context.index,'-',v.context.index,'');
    ck(v,2,0,currVal_0);
    const currVal_3:any = import0.ɵunv(v,5,0,import0.ɵnov(v,7).transform(co.timeSlotLabel(v.context.$implicit),ck(v,6,0,co.formatTime(co.parseTime(v.context.$implicit.time)))));
    ck(v,5,0,currVal_3);
  });
}
function View_OrderTimeSelectionPageComponent_7(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'timing-select-time-grid-content-group'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderTimeSelectionPageComponent_8)),
    import0.ɵdid(802816,(null as any),0,import10.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                    ']))
  ]
  ,(ck,v) => {
    const currVal_0:any = v.context.$implicit.specificTimes;
    ck(v,3,0,currVal_0);
  },(null as any));
}
function View_OrderTimeSelectionPageComponent_6(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'timing-select-time-grid drop-down'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'timing-select-time-grid-content'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderTimeSelectionPageComponent_7)),
    import0.ɵdid(802816,(null as any),0,import10.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.availableTimes.specificTimeGroups;
    ck(v,5,0,currVal_0);
  },(null as any));
}
function View_OrderTimeSelectionPageComponent_12(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),8,'div',[[
        'class',
        'timing-select-time-list-content-time'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),5,'div',[[
        'class',
        'timing-select-time-list-content-time-button'
      ]
      ],[[
        8,
        'id',
        0
      ]
      ],[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.selectTime((<any>v.parent).context.$implicit)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import10.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod([
      'unavailable',
      'carryOver'
    ]
    ),
    (l()(),import0.ɵted((null as any),[
      '\n                                    ',
      '\n                                '
    ]
    )),
    import0.ɵpod(['time']),
    import0.ɵpid(131072,import8.TranslatePipe,[
      import6.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                            ']))
  ]
  ,(ck,v) => {
    const currVal_1:any = 'timing-select-time-list-content-time-button';
    const currVal_2:any = ck(v,4,0,!(<any>v.parent).context.$implicit.available,(<any>v.parent).context.$implicit.carryOver);
    ck(v,3,0,currVal_1,currVal_2);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵinlineInterpolate(2,'time-list-button-',(<any>(<any>v.parent).parent).context.index,'-',(<any>v.parent).context.index,'');
    ck(v,2,0,currVal_0);
    const currVal_3:any = import0.ɵunv(v,5,0,import0.ɵnov(v,7).transform(co.timeSlotLabel((<any>v.parent).context.$implicit,true),ck(v,6,0,co.formatTime(co.parseTime((<any>v.parent).context.$implicit.time)))));
    ck(v,5,0,currVal_3);
  });
}
function View_OrderTimeSelectionPageComponent_11(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderTimeSelectionPageComponent_12)),
    import0.ɵdid(16384,(null as any),0,import10.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                        ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.showTimeInList(v.context.$implicit);
    ck(v,3,0,currVal_0);
  },(null as any));
}
function View_OrderTimeSelectionPageComponent_10(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderTimeSelectionPageComponent_11)),
    import0.ɵdid(802816,(null as any),0,import10.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                    ']))
  ]
  ,(ck,v) => {
    const currVal_0:any = v.context.$implicit.specificTimes;
    ck(v,3,0,currVal_0);
  },(null as any));
}
function View_OrderTimeSelectionPageComponent_9(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'timing-select-time-list drop-down'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'timing-select-time-list-content'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderTimeSelectionPageComponent_10)),
    import0.ɵdid(802816,(null as any),0,import10.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.availableTimes.specificTimeGroups;
    ck(v,5,0,currVal_0);
  },(null as any));
}
function View_OrderTimeSelectionPageComponent_13(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'timing-select-message'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                ',
      '\n            '
    ]
    )),
    import0.ɵpod(['date']),
    import0.ɵpid(131072,import8.TranslatePipe,[
      import6.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,3).transform('woa.message.order-time.earliestDate',ck(v,2,0,co.formattedEarliestLocalDate)));
    ck(v,1,0,currVal_0);
  });
}
function View_OrderTimeSelectionPageComponent_14(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),8,'div',[[
        'class',
        'timing-select-message'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import0.ɵpid(131072,import8.TranslatePipe,[
      import6.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-spinner',([] as any[]),(null as any),(null as any),(null as any),import11.View_SpinnerComponent_0,import11.RenderType_SpinnerComponent)),
    import0.ɵdid(49152,(null as any),0,import12.SpinnerComponent,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,3,0,import0.ɵnov(v,4).transform('woa.message.order-time.loadingTimes'));
    ck(v,3,0,currVal_0);
  });
}
function View_OrderTimeSelectionPageComponent_15(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'timing-select-message'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                ',
      '\n            '
    ]
    )),
    import0.ɵpod(['storeName']),
    import0.ɵpid(131072,import8.TranslatePipe,[
      import6.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,3).transform(co.noTimesMessage,ck(v,2,0,((co.orderingContextModel.currentStore == null)? (null as any): co.orderingContextModel.currentStore.name))));
    ck(v,1,0,currVal_0);
  });
}
function View_OrderTimeSelectionPageComponent_16(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'timing-select-message'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                ',
      '\n            '
    ]
    )),
    import0.ɵpid(131072,import8.TranslatePipe,[
      import6.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform('woa.message.order-time.canOnlyOrderNow'));
    ck(v,1,0,currVal_0);
  });
}
function View_OrderTimeSelectionPageComponent_17(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-button',[
      [
        'id',
        'confirm-time-button'
      ]
      ,
      [
        'woa-page-footer-control',
        ''
      ]

    ]
    ,[
      [
        2,
        'override-flat-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-flat-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-border-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'invisible',
        (null as any)
      ]
      ,
      [
        2,
        'hovered',
        (null as any)
      ]
      ,
      [
        2,
        'native',
        (null as any)
      ]
      ,
      [
        2,
        'woa-button',
        (null as any)
      ]
      ,
      [
        2,
        'tier-first',
        (null as any)
      ]
      ,
      [
        2,
        'tier-second',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-high',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-low',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-affirmative',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-dissuasive',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-negative',
        (null as any)
      ]
      ,
      [
        2,
        'shape-square',
        (null as any)
      ]
      ,
      [
        2,
        'shape-rounded',
        (null as any)
      ]
      ,
      [
        2,
        'shape-oval',
        (null as any)
      ]
      ,
      [
        2,
        'style-flat',
        (null as any)
      ]
      ,
      [
        2,
        'style-outline',
        (null as any)
      ]
      ,
      [
        2,
        'style-raised',
        (null as any)
      ]
      ,
      [
        2,
        'layout-vertical',
        (null as any)
      ]
      ,
      [
        2,
        'layout-horizontal',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.confirmTime()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import13.View_ButtonComponent_0,import13.RenderType_ButtonComponent)),
    import0.ɵdid(245760,(null as any),0,import14.ButtonComponent,[
      import0.ElementRef,
      import15.SessionModel,
      import0.ChangeDetectorRef,
      import16.ResponsiveService
    ]
    ,{
      label: [
        0,
        'label'
      ]
      ,
      disabled: [
        1,
        'disabled'
      ]

    }
    ,(null as any)),
      import0.ɵdid(16384,[[
        3,
        4
      ]
    ],0,import17.PageFooterControlDirective,([] as any[]),(null as any),(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_27:any = 'woa.button.order-time.confirmTime';
    const currVal_28:boolean = (((!co.timesAvailable || !co.orderTime) || co.showDateSelect) || co.showTimeSelect);
    ck(v,1,0,currVal_27,currVal_28);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).overrideFlatBackgroundColor;
    const currVal_1:any = import0.ɵnov(v,1).overrideFlatForegroundColor;
    const currVal_2:any = import0.ɵnov(v,1).overrideOutlineBackgroundColor;
    const currVal_3:any = import0.ɵnov(v,1).overrideOutlineForegroundColor;
    const currVal_4:any = import0.ɵnov(v,1).overrideOutlineBorderColor;
    const currVal_5:any = import0.ɵnov(v,1).overrideRaisedBackgroundColor;
    const currVal_6:any = import0.ɵnov(v,1).overrideRaisedForegroundColor;
    const currVal_7:any = import0.ɵnov(v,1).disabled;
    const currVal_8:any = import0.ɵnov(v,1).invisible;
    const currVal_9:any = import0.ɵnov(v,1).hovered;
    const currVal_10:any = import0.ɵnov(v,1).native;
    const currVal_11:any = import0.ɵnov(v,1).button;
    const currVal_12:any = import0.ɵnov(v,1).firstTier;
    const currVal_13:any = import0.ɵnov(v,1).secondTier;
    const currVal_14:any = import0.ɵnov(v,1).highProminence;
    const currVal_15:any = import0.ɵnov(v,1).lowProminence;
    const currVal_16:any = import0.ɵnov(v,1).affirmativeConnotation;
    const currVal_17:any = import0.ɵnov(v,1).dissuasiveConnotation;
    const currVal_18:any = import0.ɵnov(v,1).negativeConnotation;
    const currVal_19:any = import0.ɵnov(v,1).squareShape;
    const currVal_20:any = import0.ɵnov(v,1).roundedShape;
    const currVal_21:any = import0.ɵnov(v,1).ovalShape;
    const currVal_22:any = import0.ɵnov(v,1).flatStyle;
    const currVal_23:any = import0.ɵnov(v,1).outlineStyle;
    const currVal_24:any = import0.ɵnov(v,1).raisedStyle;
    const currVal_25:any = import0.ɵnov(v,1).verticalLayout;
    const currVal_26:any = import0.ɵnov(v,1).horizontalLayout;
    ck(v,0,1,[
      currVal_0,
      currVal_1,
      currVal_2,
      currVal_3,
      currVal_4,
      currVal_5,
      currVal_6,
      currVal_7,
      currVal_8,
      currVal_9,
      currVal_10,
      currVal_11,
      currVal_12,
      currVal_13,
      currVal_14,
      currVal_15,
      currVal_16,
      currVal_17,
      currVal_18,
      currVal_19,
      currVal_20,
      currVal_21,
      currVal_22,
      currVal_23,
      currVal_24,
      currVal_25,
      currVal_26
    ]
    );
  });
}
function View_OrderTimeSelectionPageComponent_18(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-button',[
      [
        'id',
        'confirm-asap-button'
      ]
      ,
      [
        'woa-page-footer-control',
        ''
      ]

    ]
    ,[
      [
        2,
        'override-flat-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-flat-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-border-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'invisible',
        (null as any)
      ]
      ,
      [
        2,
        'hovered',
        (null as any)
      ]
      ,
      [
        2,
        'native',
        (null as any)
      ]
      ,
      [
        2,
        'woa-button',
        (null as any)
      ]
      ,
      [
        2,
        'tier-first',
        (null as any)
      ]
      ,
      [
        2,
        'tier-second',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-high',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-low',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-affirmative',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-dissuasive',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-negative',
        (null as any)
      ]
      ,
      [
        2,
        'shape-square',
        (null as any)
      ]
      ,
      [
        2,
        'shape-rounded',
        (null as any)
      ]
      ,
      [
        2,
        'shape-oval',
        (null as any)
      ]
      ,
      [
        2,
        'style-flat',
        (null as any)
      ]
      ,
      [
        2,
        'style-outline',
        (null as any)
      ]
      ,
      [
        2,
        'style-raised',
        (null as any)
      ]
      ,
      [
        2,
        'layout-vertical',
        (null as any)
      ]
      ,
      [
        2,
        'layout-horizontal',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.confirmASAP()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import13.View_ButtonComponent_0,import13.RenderType_ButtonComponent)),
    import0.ɵdid(245760,(null as any),0,import14.ButtonComponent,[
      import0.ElementRef,
      import15.SessionModel,
      import0.ChangeDetectorRef,
      import16.ResponsiveService
    ]
    ,{
      label: [
        0,
        'label'
      ]
      ,
      disabled: [
        1,
        'disabled'
      ]
      ,
      prominence: [
        2,
        'prominence'
      ]

    }
    ,(null as any)),
      import0.ɵdid(16384,[[
        3,
        4
      ]
    ],0,import17.PageFooterControlDirective,([] as any[]),(null as any),(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_27:any = (!co.canOrderLaterTime? 'woa.button.common.ok': 'woa.button.order-time.confirmAsap');
    const currVal_28:any = (co.showDateSelect || co.showTimeSelect);
    const currVal_29:any = co.ButtonProminence.LOW;
    ck(v,1,0,currVal_27,currVal_28,currVal_29);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).overrideFlatBackgroundColor;
    const currVal_1:any = import0.ɵnov(v,1).overrideFlatForegroundColor;
    const currVal_2:any = import0.ɵnov(v,1).overrideOutlineBackgroundColor;
    const currVal_3:any = import0.ɵnov(v,1).overrideOutlineForegroundColor;
    const currVal_4:any = import0.ɵnov(v,1).overrideOutlineBorderColor;
    const currVal_5:any = import0.ɵnov(v,1).overrideRaisedBackgroundColor;
    const currVal_6:any = import0.ɵnov(v,1).overrideRaisedForegroundColor;
    const currVal_7:any = import0.ɵnov(v,1).disabled;
    const currVal_8:any = import0.ɵnov(v,1).invisible;
    const currVal_9:any = import0.ɵnov(v,1).hovered;
    const currVal_10:any = import0.ɵnov(v,1).native;
    const currVal_11:any = import0.ɵnov(v,1).button;
    const currVal_12:any = import0.ɵnov(v,1).firstTier;
    const currVal_13:any = import0.ɵnov(v,1).secondTier;
    const currVal_14:any = import0.ɵnov(v,1).highProminence;
    const currVal_15:any = import0.ɵnov(v,1).lowProminence;
    const currVal_16:any = import0.ɵnov(v,1).affirmativeConnotation;
    const currVal_17:any = import0.ɵnov(v,1).dissuasiveConnotation;
    const currVal_18:any = import0.ɵnov(v,1).negativeConnotation;
    const currVal_19:any = import0.ɵnov(v,1).squareShape;
    const currVal_20:any = import0.ɵnov(v,1).roundedShape;
    const currVal_21:any = import0.ɵnov(v,1).ovalShape;
    const currVal_22:any = import0.ɵnov(v,1).flatStyle;
    const currVal_23:any = import0.ɵnov(v,1).outlineStyle;
    const currVal_24:any = import0.ɵnov(v,1).raisedStyle;
    const currVal_25:any = import0.ɵnov(v,1).verticalLayout;
    const currVal_26:any = import0.ɵnov(v,1).horizontalLayout;
    ck(v,0,1,[
      currVal_0,
      currVal_1,
      currVal_2,
      currVal_3,
      currVal_4,
      currVal_5,
      currVal_6,
      currVal_7,
      currVal_8,
      currVal_9,
      currVal_10,
      currVal_11,
      currVal_12,
      currVal_13,
      currVal_14,
      currVal_15,
      currVal_16,
      currVal_17,
      currVal_18,
      currVal_19,
      currVal_20,
      currVal_21,
      currVal_22,
      currVal_23,
      currVal_24,
      currVal_25,
      currVal_26
    ]
    );
  });
}
export function View_OrderTimeSelectionPageComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵqud(402653184,1,{pageLayout: 0}),
    (l()(),import0.ɵeld(0,(null as any),(null as any),53,'woa-modal-page-layout',([] as any[]),(null as any),(null as any),(null as any),import18.View_ModalPageLayoutComponent_0,import18.RenderType_ModalPageLayoutComponent)),
    import0.ɵdid(114688,(null as any),2,import19.ModalPageLayoutComponent,[
      import20.Page,
      import7.NavigationService
    ]
      ,{title: [
        0,
        'title'
      ]
    },(null as any)),
    import0.ɵqud(603979776,2,{contentMessages: 1}),
    import0.ɵqud(603979776,3,{footerControls: 1}),
      import0.ɵprd(2048,[[
        1,
        4
      ]
    ],import20.PageLayout,(null as any),[import19.ModalPageLayoutComponent]),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),3,1,(null as any),View_OrderTimeSelectionPageComponent_1)),
    import0.ɵdid(16384,(null as any),0,import10.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),4,37,'div',[
      [
        'class',
        'timing'
      ]
      ,
      [
        'woa-responsive',
        ''
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import10.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod(['with-store-closed']),
    import0.ɵdid(737280,(null as any),0,import21.ResponsiveDirective,[
      import0.ElementRef,
      import16.ResponsiveService,
      import7.NavigationService,
      import0.ChangeDetectorRef,
      import0.Renderer2
    ]
    ,(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'timing-selection'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderTimeSelectionPageComponent_2)),
    import0.ɵdid(16384,(null as any),0,import10.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderTimeSelectionPageComponent_3)),
    import0.ɵdid(16384,(null as any),0,import10.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),22,'div',[[
        'class',
        'timing-select'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderTimeSelectionPageComponent_4)),
    import0.ɵdid(16384,(null as any),0,import10.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderTimeSelectionPageComponent_6)),
    import0.ɵdid(16384,(null as any),0,import10.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderTimeSelectionPageComponent_9)),
    import0.ɵdid(16384,(null as any),0,import10.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderTimeSelectionPageComponent_13)),
    import0.ɵdid(16384,(null as any),0,import10.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderTimeSelectionPageComponent_14)),
    import0.ɵdid(16384,(null as any),0,import10.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderTimeSelectionPageComponent_15)),
    import0.ɵdid(16384,(null as any),0,import10.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderTimeSelectionPageComponent_16)),
    import0.ɵdid(16384,(null as any),0,import10.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),7,1,(null as any),View_OrderTimeSelectionPageComponent_17)),
    import0.ɵdid(16384,(null as any),0,import10.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),7,1,(null as any),View_OrderTimeSelectionPageComponent_18)),
    import0.ɵdid(16384,(null as any),0,import10.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import22.OrderTimeSelectionPageComponent = v.component;
    const currVal_0:any = 'woa.heading.order-time.title';
    ck(v,2,0,currVal_0);
    const currVal_1:any = co.showStoreClosed;
    ck(v,8,0,currVal_1);
    const currVal_2:any = 'timing';
    const currVal_3:any = ck(v,12,0,co.showStoreClosed);
    ck(v,11,0,currVal_2,currVal_3);
    ck(v,13,0);
    const currVal_4:any = co.canOrderLater;
    ck(v,18,0,currVal_4);
    const currVal_5:any = co.canOrderLaterTime;
    ck(v,21,0,currVal_5);
    const currVal_6:any = co.showDateSelect;
    ck(v,27,0,currVal_6);
    const currVal_7:any = (co.showTimeSelect && co.sessionModel.currentApp.showTimeGrid);
    ck(v,30,0,currVal_7);
    const currVal_8:any = (co.showTimeSelect && !co.sessionModel.currentApp.showTimeGrid);
    ck(v,33,0,currVal_8);
    const currVal_9:any = co.showEarliestDate;
    ck(v,36,0,currVal_9);
    const currVal_10:any = co.loadingTimes;
    ck(v,39,0,currVal_10);
    const currVal_11:boolean = (!co.timesAvailable && !co.loadingTimes);
    ck(v,42,0,currVal_11);
    const currVal_12:boolean = !co.canOrderLaterTime;
    ck(v,45,0,currVal_12);
    const currVal_13:any = co.canOrderLaterTime;
    ck(v,50,0,currVal_13);
    const currVal_14:any = co.showAsap;
    ck(v,53,0,currVal_14);
  },(null as any));
}
function View_OrderTimeSelectionPageComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-order-time-selection-page',([] as any[]),(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).onClick($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },View_OrderTimeSelectionPageComponent_0,RenderType_OrderTimeSelectionPageComponent)),
    import0.ɵdid(49152,(null as any),0,import22.OrderTimeSelectionPageComponent,[
      import23.NavigationParams,
      import7.NavigationService,
      import0.ChangeDetectorRef,
      import15.SessionModel,
      import24.OrderingContextModel,
      import25.OrderModel
    ]
    ,(null as any),(null as any)),
    import0.ɵprd(6144,(null as any),import20.Page,(null as any),[import22.OrderTimeSelectionPageComponent])
  ]
  ,(null as any),(null as any));
}
export const OrderTimeSelectionPageComponentNgFactory:import0.ComponentFactory<import22.OrderTimeSelectionPageComponent> = import0.ɵccf('woa-order-time-selection-page',import22.OrderTimeSelectionPageComponent,View_OrderTimeSelectionPageComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/app/ordering-context/order-time-selection-page/order-time-selection-page.component.ngfactory.ts